var processInclude = require("base/util");

if ($("#cbt-site-location").length) {
    processInclude(require("cbt/components/cbtContactUs"));
}

$(document).ready(function () {
    processInclude(require("./contactUs/contactUs"));
});
